import { App as CapacitorApp } from "@capacitor/app";
import { useEffect } from "react";
import { useSession } from "@/lib/auth-client";
import {
  registerForPush,
  setupPushListeners,
} from "@/lib/notifications/push-registration";

/**
 * Drives native push registration: attaches the token/tap listeners once and
 * registers for push under each live session, again on each foreground until
 * a token upload lands. Mount once in the app shell.
 */
export function usePushRegistration(): void {
  const { data } = useSession();
  const sessionId = data?.session.id ?? null;

  useEffect(() => {
    void setupPushListeners();
  }, []);

  useEffect(() => {
    if (!sessionId) {
      return;
    }
    // Attach listeners before register() so the initial `registration` token
    // can't fire before its listener exists (setupPushListeners is idempotent).
    void (async () => {
      await setupPushListeners();
      await registerForPush(sessionId);
    })();
    const resume = CapacitorApp.addListener(
      "appStateChange",
      ({ isActive }) => {
        if (isActive) {
          void registerForPush(sessionId);
        }
      }
    );
    return () => {
      void resume.then((handle) => handle.remove());
    };
  }, [sessionId]);
}
